import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import React, { useState, useEffect } from "react";
import "./TestReportCard.css";
import TableTestReportCard from "./TableTestReportCard";
import DropDown from "../../Reports/DummyReportPage/Dropdown";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import { useLocation as useRouterLocation } from "react-router-dom";
import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
import ErrorImg from "./../../../Assets/Images/CommanImages/Error.png";

const TestReportCard = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
  setPagePath,
  setNoTimeSet,
}) => {
  const dispatch = useDispatch();
  const { coursesdata } = useSelector((state) => state.course);
  const { state: routerState } = useRouterLocation();
  const [selectedCourseId, setSelectedCourseId] = useState("");
  const [batchData, setBatchData] = useState([]);
  const [selectedTestId, setSelectedTestId] = useState("");
  const [testnamedata, setTestNameData] = useState([]);
  const [resultsData, setResultsData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [isApplied, setIsApplied] = useState(false);
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const [resetKey, setResetKey] = useState(0);
  const [selectedBatchId, setSelectedBatchId] = useState("");
  const [selectedTestType, setSelectedTestType] = useState("");
  const [isVisible, setIsVisible] = useState(true); // For toggling sections visibility
  const [isExpanded, setIsExpanded] = useState(false); // For table expansion

  const [sessionData, setSessionData] = useState([]);
  const [selectedSessionId, setSelectedSessionId] = useState("");

  const [value, setValues] = useState({
    report_title: "",
    course_id: "",
    session_id: "",
    batch_id: "",
    assessment_id: "",
    test_schedule_id: "",
    dpp_schedule_id: "",
    assessment_name: "",
    description: "",
  });
  const navigate = useNavigate();

  useEffect(() => {
    setPagePath("Reports > Reports Dashboard > Test Report Card");
    dispatch(fetchCourseData());
  }, [dispatch]);

  const [searchParams] = useSearchParams();
  const reportName = searchParams.get("reportName");

  const fetchBatchesByCourse = async () => {
    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/get-batches-by-course/?course_id=${value.course_id}`
      );
      const data = await response.json();
      setBatchData(data || []);
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: error.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const fetchSessionsData = async () => {
    try {
      const response = await fetch(`${FULL_API_BASE_URL}/get-sessions-list`, {
        method: "GET",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();

      if (result.status === 200 && result.data) {
        const formattedSessions = result.data.map((session) => ({
          id: session.session_id,
          label: session.session_name,
        }));
        setSessionData(formattedSessions);
      }
    } catch (error) {
      console.error("Error fetching sessions data:", error);
    }
  };

  useEffect(() => {
    fetchSessionsData();
  }, []);

  useEffect(() => {
    if (value.course_id) {
      fetchBatchesByCourse();
    }
  }, [value.course_id]);

  const AssesmentTypeId = 2;
  const fetchTestDetailsByBatch = async () => {
    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/get-assessment-detail-by-batch-id/?batch_id=${value.batch_id}&assessment_type_id=${AssesmentTypeId}`
      );
      const result = await response.json();

      if (result && result.data && result.data.results) {
        setTestNameData(result.data.results);
      } else {
        setTestNameData([]);
      }
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: error.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  useEffect(() => {
    if (value.batch_id) {
      fetchTestDetailsByBatch();
    }
  }, [value.batch_id]);

  // const [isLoading, setIsLoading] = useState(false);

  // const fetchResultsData = async () => {
  //   // ✅ Prevent auto-close while loading
  //   setNoTimeSet(true);

  //   setIsLoading(true);
  //   setIsMessageBoxVisible(true);
  //   setMessageBox(
  //     <div className="Container-messageBOX">
  //       <div className="messagebox-insider1">
  //         <div className="loader-tc"></div>
  //         <span style={{ marginLeft: "10px", marginTop: "3px" }}>
  //           Loading data, please wait...
  //         </span>
  //       </div>
  //     </div>
  //   );
  //   setActiveImg(false);

  //   try {
  //     let apiUrl = `${FULL_API_BASE_URL}/get-result-dictionary-v3/?`;

  //     // ✅ Determine API param
  //     if (selectedTestType === "assessment") {
  //       apiUrl += `assessment_id=${value.assessment_id}`;
  //     } else if (selectedTestType === "test_schedule") {
  //       apiUrl += `test_schedule_id=${value.test_schedule_id}`;
  //     } else if (selectedTestType === "dpp_schedule") {
  //       apiUrl += `dpp_schedule_id=${value.dpp_schedule_id}`;
  //     } else {
  //       setIsLoading(false);
  //       setNoTimeSet(false);
  //       setIsMessageBoxVisible(true);
  //       setMessageBox(
  //         <div className="Container-messageBOX">
  //           <div className="messagebox-insider1">
  //             <span style={{ marginLeft: "10px", marginTop: "3px" }}>
  //               Please select a test to view the report.
  //             </span>
  //           </div>
  //         </div>
  //       );
  //       setActiveImg(ErrorImg);
  //       setIsApplied(false);
  //       return;
  //     }

  //     const response = await fetch(apiUrl);
  //     const data = await response.json();

  //     // ✅ Common test name fallback
  //     const testName =
  //       value?.assessment_name ||
  //       value?.test_name ||
  //       value?.dpp_name ||
  //       "selected test";

  //     // =========================
  //     // ✅ SUCCESS CASE
  //     // =========================
  //     if (data.status === 200 && data.message === "Success") {
  //       if (!Array.isArray(data.data) || data.data.length === 0) {
  //         setIsLoading(false);
  //         setNoTimeSet(false);
  //         setIsMessageBoxVisible(true);

  //         setMessageBox(
  //           <div className="Container-messageBOX">
  //             <div className="messagebox-insider1">
  //               <span style={{ marginLeft: "10px", marginTop: "3px" }}>
  //                 Data not found for {testName}.
  //               </span>
  //             </div>
  //           </div>
  //         );

  //         setActiveImg(false);
  //       } else {
  //         // ✅ Populate table
  //         setHeaders(data.data[0]);
  //         setResultsData(data.data.slice(1));

  //         setIsLoading(false);
  //         setNoTimeSet(false);
  //         setIsMessageBoxVisible(false); // close loader
  //       }

  //     // =========================
  //     // ✅ 404 CASE (IMPORTANT)
  //     // =========================
  //     } else if (data.status === 404) {
  //       setIsLoading(false);
  //       setNoTimeSet(false);
  //       setIsMessageBoxVisible(true);

  //       setMessageBox(
  //         <div className="Container-messageBOX">
  //           <div className="messagebox-insider1">
  //             <span style={{ marginLeft: "10px", marginTop: "3px" }}>
  //               {data.message || `No results found for ${testName}.`}
  //             </span>
  //           </div>
  //         </div>
  //       );

  //       setActiveImg(false); // or ErrorImg if you prefer

  //     // =========================
  //     // ❌ OTHER ERROR CASE
  //     // =========================
  //     } else {
  //       setIsLoading(false);
  //       setNoTimeSet(false);
  //       setIsMessageBoxVisible(true);

  //       setMessageBox(
  //         <div className="Container-messageBOX">
  //           <div className="messagebox-insider1">
  //             <span style={{ marginLeft: "10px", marginTop: "3px" }}>
  //               Something went wrong. Please try again.
  //             </span>
  //           </div>
  //         </div>
  //       );

  //       setActiveImg(ErrorImg);
  //     }

  //   } catch (error) {
  //     // =========================
  //     // ❌ NETWORK / RUNTIME ERROR
  //     // =========================
  //     setIsLoading(false);
  //     setNoTimeSet(false);
  //     setIsMessageBoxVisible(true);

  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <span>Error: {error.message}</span>
  //         </div>
  //       </div>
  //     );

  //     setActiveImg(ErrorImg);
  //   }
  // };

  const [isLoading, setIsLoading] = useState(false);

  const fetchResultsData = async () => {
    // ✅ Prevent auto-close while loading
    setNoTimeSet(true);

    setIsLoading(true);
    setIsMessageBoxVisible(true);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span style={{ marginLeft: "10px", marginTop: "3px" }}>
            Loading data, please wait...
          </span>
        </div>
      </div>
    );
    setActiveImg(false);

    // ⏱️ Show "taking more time" message if API takes longer than 10 seconds
    const slowLoadingTimer = setTimeout(() => {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span style={{ marginLeft: "10px", marginTop: "3px" }}>
              This is taking longer than usual, please wait a moment...
            </span>
          </div>
        </div>
      );
    }, 10000);

    try {
      let apiUrl = `${FULL_API_BASE_URL}/get-result-dictionary-v3/?`;

      // ✅ Determine API param
      if (selectedTestType === "assessment") {
        apiUrl += `assessment_id=${value.assessment_id}`;
      } else if (selectedTestType === "test_schedule") {
        apiUrl += `test_schedule_id=${value.test_schedule_id}`;
      } else if (selectedTestType === "dpp_schedule") {
        apiUrl += `dpp_schedule_id=${value.dpp_schedule_id}`;
      } else {
        clearTimeout(slowLoadingTimer); // ✅ Clear timer
        setIsLoading(false);
        setNoTimeSet(false);
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span style={{ marginLeft: "10px", marginTop: "3px" }}>
                Please select a test to view the report.
              </span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        setIsApplied(false);
        return;
      }

      const response = await fetch(apiUrl);
      const data = await response.json();

      // ✅ Common test name fallback
      const testName =
        value?.assessment_name ||
        value?.test_name ||
        value?.dpp_name ||
        "selected test";

      // =========================
      // ✅ SUCCESS CASE
      // =========================
      if (data.status === 200 && data.message === "Success") {
        clearTimeout(slowLoadingTimer); // ✅ Clear timer

        if (!Array.isArray(data.data) || data.data.length === 0) {
          setIsLoading(false);
          setNoTimeSet(false);
          setIsMessageBoxVisible(true);

          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <span style={{ marginLeft: "10px", marginTop: "3px" }}>
                  Data not found for {testName}.
                </span>
              </div>
            </div>
          );

          setActiveImg(false);
        } else {
          // ✅ Populate table
          setHeaders(data.data[0]);
          setResultsData(data.data.slice(1));

          setIsLoading(false);
          setNoTimeSet(false);
          setIsMessageBoxVisible(false); // close loader
        }

        // =========================
        // ✅ 404 CASE
        // =========================
      } else if (data.status === 404) {
        clearTimeout(slowLoadingTimer); // ✅ Clear timer
        setIsLoading(false);
        setNoTimeSet(false);
        setIsMessageBoxVisible(true);

        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span style={{ marginLeft: "10px", marginTop: "3px" }}>
                {data.message || `No results found for ${testName}.`}
              </span>
            </div>
          </div>
        );

        setActiveImg(false);

        // =========================
        // ❌ OTHER ERROR CASE
        // =========================
      } else {
        clearTimeout(slowLoadingTimer); // ✅ Clear timer
        setIsLoading(false);
        setNoTimeSet(false);
        setIsMessageBoxVisible(true);

        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span style={{ marginLeft: "10px", marginTop: "3px" }}>
                Something went wrong. Please try again.
              </span>
            </div>
          </div>
        );

        setActiveImg(ErrorImg);
      }
    } catch (error) {
      // =========================
      // ❌ NETWORK / RUNTIME ERROR
      // =========================
      clearTimeout(slowLoadingTimer); // ✅ Clear timer
      setIsLoading(false);
      setNoTimeSet(false);
      setIsMessageBoxVisible(true);

      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>Error: {error.message}</span>
          </div>
        </div>
      );

      setActiveImg(ErrorImg);
    }
  };

  const handleApplyOrReset = () => {
    if (isApplied) {
      setIsApplied(false);
      setIsLoading(false);
      setResultsData([]);
      setHeaders([]);
      setIsColumnDivVisible(false);
      setIsMessageBoxVisible(false);
      setNoTimeSet(false); // ✅ ADD THIS

      setValues((prevValues) => ({
        ...prevValues,
        report_title: "",
        description: "",
      }));
    } else {
      setIsApplied(true);
      fetchResultsData();
    }
  };

  const dropdownStyle = isApplied
    ? { opacity: 0.5, pointerEvents: "none" }
    : { opacity: 1, pointerEvents: "auto" };

  const data = (Array.isArray(resultsData) ? resultsData : []).map((student) =>
    headers.map((header, index) => student[index])
  );

  const course =
    coursesdata && coursesdata.length > 0
      ? coursesdata.find((course) => course.course_id === selectedCourseId)
          ?.course_description || ""
      : "";

  const batch =
    batchData && batchData.length > 0
      ? batchData.find((batch) => batch.batch_id === selectedBatchId)
          ?.batch_name || ""
      : "";

  const getTestDate = () => {
    if (!resultsData || resultsData.length === 0) return "";
    const dateIndex = headers.indexOf("Test Date");
    if (dateIndex === -1) return "";
    return resultsData[0][dateIndex] || "";
  };

  const getTestDisplayName = () => {
    if (!testnamedata || testnamedata.length === 0) return "";

    const selectedTest = testnamedata.find((test) => {
      if (test.type === "test_schedule") {
        return test.test_schedule_id === selectedTestId;
      } else if (test.type === "dpp_schedule") {
        return test.dpp_schedule_id === selectedTestId;
      } else if (test.type === "assessment") {
        return test.assessment_id === selectedTestId;
      }
      return false;
    });

    if (!selectedTest) return "";

    if (selectedTest.type === "test_schedule") {
      return selectedTest.test_name || "";
    } else if (selectedTest.type === "dpp_schedule") {
      return selectedTest.dpp_name || "";
    } else if (selectedTest.type === "assessment") {
      return selectedTest.assessment_name || "";
    }

    return "";
  };

  const filteredBatchData = Array.isArray(batchData)
    ? batchData.filter(
        (batch) => !value.session_id || batch.session_id === value.session_id
      )
    : [];

  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "36.5px",
        marginBottom: "40px",
      }}
    >
      <div style={{ position: "sticky", top: "0" }}>
        <div className="Header-up">
          <span
            style={{
              color: "#2F2E40",
              fontSize: "30px",
              textTransform: "capitalize",
            }}
          >
            {reportName}
          </span>
          <div
            className="testreportcard-header-btn-container"
            style={{ marginRight: "30px" }}
          >
            <button
              className="testreportcard-cancel-btn"
              onClick={() => {
                navigate("/report_management");
              }}
            >
              CANCEL
            </button>
            <button
              className="testreportcard-create-btn"
              // onClick={handleApplyOrReset}
              onClick={() => {
                if (isLoading) return;
                handleApplyOrReset();
              }}
              style={{
                opacity: isLoading ? 0.6 : 1,
                cursor: isLoading ? "not-allowed" : "pointer",
              }}
            >
              {isApplied ? "RESET" : "APPLY"}
            </button>
          </div>
        </div>
        <p style={{ marginTop: "1%", color: "#2F2E40" }}>
          View, create, or filter reports. View and manage the list of reports
          already available or create a new report.
        </p>

        {/* Dropdown section with conditional rendering */}
        <div
          style={{ display: isVisible ? "block" : "none", marginTop: "1vh" }}
        >
          <div className="row-cs-uni">
            <div
              className="col-cs2"
              style={{ marginRight: "1vw", ...dropdownStyle }}
              key={`course_${resetKey}`}
            >
              <DropDown
                label="Course"
                selected={value.course_id}
                setSelected={(selectedOption) => {
                  setSelectedCourseId(selectedOption);

                  setValues((prev) => ({
                    ...prev,
                    course_id: selectedOption,
                    session_id: "", // ✅ RESET session
                    batch_id: "", // ✅ RESET batch
                    assessment_id: "",
                    test_schedule_id: "",
                    dpp_schedule_id: "",
                    assessment_name: "",
                  }));

                  // ✅ Reset all dependent states
                  setSelectedSessionId("");
                  setSelectedBatchId("");
                  setSelectedTestId("");
                  setSelectedTestType("");

                  setBatchData([]); // optional (clean UI)
                  setTestNameData([]); // clear test dropdown

                  setResetKey((prevKey) => prevKey + 1); // force dropdown UI reset
                }}
                options={
                  coursesdata?.map((course) => ({
                    label: course.course_description,
                    id: course.course_id,
                  })) || []
                }
                isRequired="true"
              />
            </div>
            <div
              className="col-cs2"
              style={{ marginRight: "1vw", ...dropdownStyle }}
              key={`session_${resetKey}`}
            >
              <DropDown
                label="Session"
                selected={value.session_id}
                setSelected={(selectedOption) => {
                  setSelectedSessionId(selectedOption);

                  setValues((prev) => ({
                    ...prev,
                    session_id: selectedOption,
                    batch_id: "", // ✅ Reset batch
                    assessment_id: "",
                    test_schedule_id: "",
                    dpp_schedule_id: "",
                    assessment_name: "",
                  }));

                  setSelectedBatchId(""); // ✅ Reset batch state
                  setSelectedTestId(""); // ✅ Reset test selection
                  setSelectedTestType(""); // ✅ Reset test type
                  setTestNameData([]); // ✅ Clear test dropdown data

                  setResetKey((prevKey) => prevKey + 1); // ✅ Force dropdown reset UI
                }}
                options={sessionData} // ✅ API data
                isRequired="true"
              />
            </div>
            <div
              className="col-cs2"
              style={{ marginRight: "1vw", ...dropdownStyle }}
              key={`batch_${resetKey}`}
            >
              <DropDown
                label="Batch"
                selected={value.batch_id}
                setSelected={(selectedOption) => {
                  setSelectedBatchId(selectedOption);
                  setValues({
                    ...value,
                    batch_id: selectedOption,
                    assessment_id: "",
                    test_schedule_id: "",
                    dpp_schedule_id: "",
                  });
                  setSelectedTestType("");
                }}
                options={filteredBatchData.map((batch) => ({
                  label: batch.batch_name,
                  id: batch.batch_id,
                }))}
                isRequired="true"
              />
            </div>
          </div>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle, marginTop: "12px" }}
            key={`test_${resetKey}`}
          >
            <DropDown
              label="Test"
              selected={
                value.assessment_id ||
                value.test_schedule_id ||
                value.dpp_schedule_id
              }
              setSelected={(selectedOption) => {
                const selectedTest = Array.isArray(testnamedata)
                  ? testnamedata.find((test) => {
                      if (test.type === "test_schedule") {
                        return test.test_schedule_id === selectedOption;
                      } else if (test.type === "dpp_schedule") {
                        return test.dpp_schedule_id === selectedOption;
                      } else if (test.type === "assessment") {
                        return test.assessment_id === selectedOption;
                      }
                      return false;
                    })
                  : null;

                setSelectedTestId(selectedOption);

                let assessmentName = "";
                let newValues = {
                  ...value,
                  assessment_id: "",
                  test_schedule_id: "",
                  dpp_schedule_id: "",
                };

                if (selectedTest) {
                  setSelectedTestType(selectedTest.type);

                  if (selectedTest.type === "test_schedule") {
                    assessmentName = selectedTest.test_name || "";
                    newValues.test_schedule_id = selectedTest.test_schedule_id;
                  } else if (selectedTest.type === "dpp_schedule") {
                    assessmentName = selectedTest.dpp_name || "";
                    newValues.dpp_schedule_id = selectedTest.dpp_schedule_id;
                  } else if (selectedTest.type === "assessment") {
                    assessmentName = selectedTest.assessment_name || "";
                    newValues.assessment_id = selectedTest.assessment_id;
                  }

                  newValues.assessment_name = assessmentName;
                }

                setValues(newValues);
              }}
              options={
                Array.isArray(testnamedata) && testnamedata.length > 0
                  ? testnamedata.map((test) => {
                      let label = "";
                      let id = "";

                      if (test.type === "test_schedule") {
                        label = test.test_name || "";
                        id = test.test_schedule_id;
                      } else if (test.type === "dpp_schedule") {
                        label = test.dpp_name || "";
                        id = test.dpp_schedule_id;
                      } else if (test.type === "assessment") {
                        label = test.assessment_name || "";
                        id = test.assessment_id;
                      }

                      return { label, id };
                    })
                  : [{ label: "", id: "" }]
              }
              Height="auto"
              OverFlow="auto"
              minheight="300px"
              isRequired="true"
            />
          </div>
        </div>

        {/* Three-dot toggle button - Exact same style as StudentDPPSummary */}
        <div style={{ position: "relative", marginTop: "20px" }}>
          <button
            style={{
              position: "absolute",
              top: "-1px",
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 1,
              width: "60px",
              height: "10px",
              backgroundColor: "white",
              border: "none",
            }}
            onClick={() => {
              setIsExpanded(!isExpanded); // Toggle the isExpanded state when clicked
              setIsVisible(!isVisible);
            }}
          >
            <p style={{ fontSize: "20px", color: "black" }}>...</p>
          </button>
          <TableTestReportCard
            headers={headers}
            data={data}
            searchPlaceholder="Search by Student Name..."
            isColumnDivVisible={isColumnDivVisible}
            setIsColumnDivVisible={setIsColumnDivVisible}
            dataClient={dataClient}
            testname={testnamedata}
            ReportPageHeader="Test Report Card"
            course={course}
            batch={batch}
            test={getTestDisplayName()}
            date={getTestDate()}
            isExpanded={isExpanded} // Pass the isExpanded prop
          />
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default TestReportCard;

// const fetchResultsData = async () => {
//     setIsLoading(true);
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span style={{ marginLeft: "10px", marginTop: "3px" }}>
//             Loading data, please wait...
//           </span>
//         </div>
//       </div>
//     );
//     setActiveImg(false);

//   try {
//     let apiUrl = `${FULL_API_BASE_URL}/get-result-dictionary-v3/?`;

//     if (selectedTestType === "assessment") {
//       apiUrl += `assessment_id=${value.assessment_id}`;
//     } else if (selectedTestType === "test_schedule") {
//       apiUrl += `test_schedule_id=${value.test_schedule_id}`;
//     } else if (selectedTestType === "dpp_schedule") {
//       apiUrl += `dpp_schedule_id=${value.dpp_schedule_id}`;
//     } else {
//       setIsLoading(false);
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span style={{ marginLeft: "10px", marginTop: "3px" }}>
//               Please select a test to view the report.
//             </span>
//           </div>
//           {/* <div className="messagebox-insider2">
//             <button
//               className="testreportcard-create-btn"
//               onClick={() => setIsMessageBoxVisible(false)}
//             >
//               OK
//             </button>
//           </div> */}
//         </div>
//       );
//       setActiveImg(ErrorImg);
//       setIsApplied(false);
//       return;
//     }

//     const response = await fetch(apiUrl);
//     const data = await response.json();

//     if (!data || !Array.isArray(data.data) || data.data.length === 0) {
//       setIsLoading(false);
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span style={{ marginLeft: "10px", marginTop: "3px" }}>
//               Data not found for {value.assessment_name}.
//             </span>
//           </div>
//         </div>
//       );
//       setActiveImg(false);
//     } else {
//       setHeaders(data.data[0]);
//       setResultsData(data.data.slice(1));
//       setIsLoading(false);
//       setIsMessageBoxVisible(false);
//     }
//   } catch (error) {
//     setIsLoading(false);
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>Error: {error.message}</span>
//         </div>
//         <div className="messagebox-insider2">
//           <button
//             className="testreportcard-create-btn"
//             onClick={() => setIsMessageBoxVisible(false)}
//           >
//             OK
//           </button>
//         </div>
//       </div>
//     );

//     setTimeout(function () {
//       setIsMessageBoxVisible(false);
//     }, 9000);

//     setActiveImg(ErrorImg);
//   }
// };

// const handleApplyOrReset = () => {
//   if (isApplied) {
//     setIsApplied(false);
//     setIsLoading(false);
//     setResultsData([]);
//     setHeaders([]);
//     setIsColumnDivVisible(false);
//     setIsMessageBoxVisible(false);

//     setValues((prevValues) => ({
//       ...prevValues,
//       report_title: "",
//       description: "",
//     }));
//   } else {
//     setIsApplied(true);
//     fetchResultsData();
//   }
// };

//   const fetchResultsData = async () => {
//   // ✅ Tell parent NOT to auto-close the message box
//   setNoTimeSet(true);

//   setIsLoading(true);
//   setIsMessageBoxVisible(true);
//   setMessageBox(
//     <div className="Container-messageBOX">
//       <div className="messagebox-insider1">
//         <div className="loader-tc"></div>
//         <span style={{ marginLeft: "10px", marginTop: "3px" }}>
//           Loading data, please wait...
//         </span>
//       </div>
//     </div>
//   );
//   setActiveImg(false);

//   try {
//     let apiUrl = `${FULL_API_BASE_URL}/get-result-dictionary-v3/?`;

//     if (selectedTestType === "assessment") {
//       apiUrl += `assessment_id=${value.assessment_id}`;
//     } else if (selectedTestType === "test_schedule") {
//       apiUrl += `test_schedule_id=${value.test_schedule_id}`;
//     } else if (selectedTestType === "dpp_schedule") {
//       apiUrl += `dpp_schedule_id=${value.dpp_schedule_id}`;
//     } else {
//       setIsLoading(false);
//       setNoTimeSet(false); // ✅ Re-enable auto-close
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span style={{ marginLeft: "10px", marginTop: "3px" }}>
//               Please select a test to view the report.
//             </span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorImg);
//       setIsApplied(false);
//       return;
//     }

//     const response = await fetch(apiUrl);
//     const data = await response.json();

//     if (data.status === 200 && data.message === "Success") {
//       if (!Array.isArray(data.data) || data.data.length === 0) {
//         setIsLoading(false);
//         setNoTimeSet(false); // ✅ Re-enable auto-close
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span style={{ marginLeft: "10px", marginTop: "3px" }}>
//                 Data not found for {value.assessment_name}.
//               </span>
//             </div>
//           </div>
//         );
//         setActiveImg(false);
//       } else {
//         // ✅ Success — auto remove loading box
//         setHeaders(data.data[0]);
//         setResultsData(data.data.slice(1));
//         setIsLoading(false);
//         setNoTimeSet(false); // ✅ Re-enable auto-close
//         setIsMessageBoxVisible(false); // ✅ Close immediately on success
//       }
//     } else {
//       setIsLoading(false);
//       setNoTimeSet(false); // ✅ Re-enable auto-close
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span style={{ marginLeft: "10px", marginTop: "3px" }}>
//               Something went wrong. Please try again.
//             </span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorImg);
//     }

//   } catch (error) {
//     setIsLoading(false);
//     setNoTimeSet(false); // ✅ Re-enable auto-close
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>Error: {error.message}</span>
//         </div>
//       </div>
//     );
//     setActiveImg(ErrorImg);
//   }
// };
